import { render, staticRenderFns } from "./CoursewareDefaultContainer.vue?vue&type=template&id=a28005b2&"
import script from "./CoursewareDefaultContainer.vue?vue&type=script&lang=js&"
export * from "./CoursewareDefaultContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports